module.exports = __webpack_public_path__ + "res/snake_dash.abc646520906bbdbe03074e109e2ea40.webp";